import { Certifications } from '@/components/sections/certifications';

export function CertificationsPage() {
  return (
    <div className="container">
      <Certifications />
    </div>
  );
}